import React from 'react';
import SkuDetailSection from './SkuDetailSection/SkuDetailSection';
import { useCalculationRedistributionSectionData } from './useCalculationRedistributionSectionData';

interface CalculationRedistributionTargetSectionProps {
  onShowSkuInfoChanged?: (showSkuInfo: boolean) => void;
}

const CalculationRedistributionTargetSection: React.FC<
  CalculationRedistributionTargetSectionProps
> = ({ onShowSkuInfoChanged }) => {
  const { redistributionData, showExecutionResult, executionResultLoading } =
    useCalculationRedistributionSectionData('Target');

  if (redistributionData) {
    return (
      <SkuDetailSection
        sourceOrTarget="Target"
        redistributionData={redistributionData}
        showExecutionResult={showExecutionResult}
        executionResultLoading={executionResultLoading}
        onShowSkuInfoChanged={onShowSkuInfoChanged}
      />
    );
  } else {
    return null;
  }
};

export default CalculationRedistributionTargetSection;
